// Remove when browser support for AbortController is better
import AbortController from "abort-controller";

class Menu {
  constructor(clickSelector, menuSelector) {
    this.currentWidth = window.innerWidth;
    this.clickSelector = clickSelector;
    this.menuSelector = menuSelector;
    this.clickTarget = document.querySelector(this.clickSelector);
    this.menuTarget = document.querySelector(this.menuSelector);
    this.duration = 400;
    this.useClickOutside = false;
    this.currentController = null;
  }

  set setDuration(duration) {
    this.duration = duration;
  }

  set setUseClickOutside(useClickOutside) {
    this.useClickOutside = useClickOutside;
  }

  boot() {
    const toggler = document.querySelector(this.clickSelector);
    const toggleEventTargetCb = () => this.toggleTarget();

    toggler
      ?.addEventListener("click", toggleEventTargetCb);
  }

  toggleTarget() {
    $(this.menuSelector).slideToggle(this.duration);

    // needs to be local to this scope
    // new event = new abort controller
    this.currentController = new AbortController();
    const signal = this.currentController.signal;

    window.addEventListener("resize", () => this.closeMenu(), { signal });

    if (this.useClickOutside) {
      const clickEventCb = (event) => this.handleClickOutside(event);
      document
        .addEventListener("click", clickEventCb, { signal });
    }
  }

  closeMenu() {
    if (this.currentWidth === window.innerWidth) {
      // Abort if the window width hasn't changed
      return;
    }

    this.currentWidth = window.innerWidth;

    if (this.menuTarget) {
      this.menuTarget.style.display = "";
    }

    this.currentController?.abort();
  }

  handleClickOutside(event) {
    const target = event.target;

    if (this.clickTarget && this.clickTarget.contains(target)) {
      return;
    }

    if (this.menuTarget && !this.menuTarget.contains(target)) {
      $(this.menuSelector).slideUp(this.duration);
    }

    this.controller?.abort();
  }
}

export function setupMenus() {
  //  __  __
  // |  \/  |   ___   _ __    _   _
  // | |\/| |  / _ \ | '_ \  | | | |
  // | |  | | |  __/ | | | | | |_| |
  // |_|  |_|  \___| |_| |_|  \__,_|s
  const main = new Menu("#toggle_navigation", ".main-nav");
  main.duration = 400;
  main.useClickOutside = true;
  main.boot();

  const search = new Menu(".search-form-toggler__button", ".search-form-toggler__content");
  search.setDuration = 100;
  search.setUseClickOutside = true;
  search.boot();

  const subNav = new Menu("#toggle_sub_navigation", "#toggle_sub_navigation + ul");
  subNav.boot();

  const startRead = new Menu(".start-read", "#readspeaker_button1");
  startRead.boot();
}
